import "core-js/modules/es.parse-int.js";
import { useMemo } from 'react';
import { useReduxSelector } from '@applyboard/ab-common';
import { verifiedDocumentForRequirement } from "../../../../store/selectors/entity_selector";
export default function useVerifiedDocument(requirementId) {
  var selector = useMemo(function () {
    return verifiedDocumentForRequirement(typeof requirementId === 'number' ? requirementId : parseInt(requirementId, 10));
  }, [requirementId]);
  return useReduxSelector(selector);
}